export const PAN_PATTERN = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
export const IFSC_PATTERN = /^[A-Z]{4}0[A-Z0-9]{6}$/;

export const normalizeIndianCode = (value) => String(value || '')
  .toUpperCase()
  .replace(/\s+/g, '');

export const validateEmployeeIdentifiers = ({ pan_no: pan, ifsc_code: ifsc }) => {
  const panNumber = normalizeIndianCode(pan);
  const ifscCode = normalizeIndianCode(ifsc);
  const errors = {};

  if (panNumber && !PAN_PATTERN.test(panNumber)) {
    errors.pan_no = 'Enter a valid PAN, for example ABCDE1234F.';
  }
  if (ifscCode && !IFSC_PATTERN.test(ifscCode)) {
    errors.ifsc_code = 'Enter a valid IFSC, for example HDFC0001234.';
  }
  return errors;
};

export const firstIdentifierError = (formData) => {
  const errors = validateEmployeeIdentifiers(formData);
  return errors.pan_no || errors.ifsc_code || '';
};
